// @ts-nocheck
import { createChainHandler, replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";
import {
    chain,
    UpdatePrice as baseUpdatePrice,
} from "@insite/client-framework/Store/Pages/ProductList/Handlers/ChangeUnitOfMeasure";
import { getProductState } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import loadRealTimePricing from "@insite/client-framework/Store/CommonHandlers/LoadRealTimePricing";

export const UpdatePrice = createChainHandler("UpdatePrice", chain, props => {
    const state = props.getState();
    const { productId, unitOfMeasure } = props.parameter;
    const product = getProductState(state, productId).value;
    if (!product || product.quoteRequired) {
        return;
    }

    const productInfo = state.pages.productList.productInfosByProductId[productId];
    if (!productInfo) {
        return;
    }

    /* Store Custom Code - Start */
    props.dispatch({
        type: "Store/Data/Products/BeginLoadRealTimePrice",
        productId,
    });
    /* Store Custom Code - End */

    props.dispatch(
        loadRealTimePricing({
            productPriceParameters: [
                {
                    productId,
                    qtyOrdered: productInfo.qtyOrdered,
                    unitOfMeasure: unitOfMeasure ?? "",
                },
            ],
            onSuccess: realTimePricing => {
                const pricing = realTimePricing.realTimePricingResults!.find(o => o.productId === productId);
                if (pricing) {
                    props.dispatch({
                        type: "Pages/ProductList/CompleteLoadRealTimePricing",
                        realTimePricing,
                    });
                } else {
                    props.dispatch({
                        type: "Pages/ProductList/FailedLoadRealTimePricing",
                        productId,
                    });
                }
                /* Store Custom Code - Start */
                props.dispatch({
                    type: "Store/Data/Products/CompleteLoadRealTimePrice",
                    productId,
                });
                /* Store Custom Code - End */
            },
            onError: () => {
                props.dispatch({
                    type: "Pages/ProductList/FailedLoadRealTimePricing",
                    productId,
                });
                /* Store Custom Code - Start */
                props.dispatch({
                    type: "Store/Data/Products/CompleteLoadRealTimePrice",
                    productId,
                });
                /* Store Custom Code - End */
            },
            onComplete(realTimePricingProps) {
                if (realTimePricingProps.apiResult) {
                    this.onSuccess?.(realTimePricingProps.apiResult);
                } else if (realTimePricingProps.error) {
                    this.onError?.(realTimePricingProps.error);
                }
            },
        }),
    );
});

replaceInChain(chain, baseUpdatePrice, UpdatePrice);
